import { cx } from '@linaria/core';
import { mdiCloseCircle } from '@mdi/js';
import Icon from '@mdi/react';
import IconButton from '../Buttons/IconButton';
import "./Tag.linaria.module.css!=!./Tag?./Tag.linaria.module.css?css=H4sIAAAAAAAAA41Ty3KEIBC85ys8JgdT4roPySV/QqEC4iK4gK+l8u+pdVcXTSqVE9VMzzAzdL9jW6P8hADtB9mR9zV0VEkbGn4lEMTN8PH1MhFIjEAr0iGRriSclRbuomdUKMSLhrJkjVyDi4JLFlrVwGghkxWZbMmZslbVHv+MqGVcxGu08AWhFp68ZsSKL7Z8PbXvJcQFsvoiBF4jl+H8zLRqZRHmSigNO6xfw9BiZsJn7G0ucxQImMM546n7QZ8uFuaOIpCUOKs7lyldEA1BMwRGCV4E/htTbMnaV4ge6EVkj6RQ44K3BgJvlLRCVpxJJFzeaqM0bBSXlug5jjXqdJeTYY0cFWQIC65JbrmSUKt+zsgIApc0z9l1A+85vcYNlOp2fHy9fNak4Dh4LVVHNAym481NicAkx904ItNnVb373xWcCvz9D/OOHu2yi//5C3I11ozLWVvexvbVovzNWj31s6sv2QXNVScFLnotIwTGJFGCbuBMvwsweZa/uS/NOtWoDfTNGK3MeDFC0/3sxXjdq7+B62YDW7eUkT/agta9LrPZFDEx9rR2lgw2tBpLQ5WuoVSSzCRAB9yLFoEqPlVD/NtdYBosf37sVK/BmkjrjQOSMT6O7QauBtp7FjAI2KHnnXAFN43AI7wpdQ63ec0rjkC9J4esCkzHHir7w+Jh1lqrZHjX8/KQLsse4VHVIL7V+UeFW+43zu74tH8FAAA="
/* CSS START: THIS BLOCK NEEDS TO BE IN THIS ORDER> */
const chipStyles = "atm_c8_1fwxnve atm_e2_1ul9x4n atm_lo_idpfg4 atm_le_idpfg4 atm_lk_ftgil2 atm_ll_ftgil2 atm_2d_trqlla atm_7l_1s6kbi9 atm_3f_14habmv atm_5j_f6fqlb atm_9j_tlke0l atm_ar_vrvcex atm_be_1q9ccgz atm_1s473yy_swbjm3";
const bottomMarginStyles = "atm_gq_ftgil2";
/* compact chips space with right margins only (first chip sits flush) —
   must come after tagListStyles in cx so this margin-left wins */
const compactStyles = "atm_5j_1fwxnve atm_lo_idpfg4 atm_le_idpfg4 atm_lk_ftgil2 atm_ll_ftgil2 atm_gz_idpfg4 atm_h0_1y44olf atm_c8_19bvopo atm_e2_qslrf5";
const tagListStyles = "atm_gz_ftgil2";
/* atomic Linaria: on a property conflict the LAST cx() argument wins —
   these zeroed margins must come after compactStyles/tagListStyles in cx */
const noFirstMarginStyles = "atm_gz_idpfg4";
const noLastMarginStyles = "atm_h0_idpfg4";
const tagLabelStyle = "atm_t9_glywfm atm_1fxawlu_1j28jx2";
const deleteIconStyles = "atm_gz_14y27yu atm_9s_1txwivl atm_ucmiji_1m5e6bj";
/* Goes in the chip IconButton's cx() rather than on the delete span: there
   it evicts Button's own `& svg { color: contrastIcons }` atom (same
   property, last wins). From the span the rule ties with Button's on
   specificity and only wins by stylesheet emission order. The delete icon is
   the only svg in a chip, so scoping it to the button is equivalent. */
const deleteIconColorStyles = "atm_9rhhw_ayom12";
/* CSS END: */

interface ITag {
  tag: string;
  tagTitle?: string;
  onClick?(tag: string, event: any): void;
  onDelete?(event): void;
  first?: boolean;
  last?: boolean;
  bottomSpacing?: boolean;
  compact?: boolean;
  tagList?: boolean;
  className?: string;
}
const Tag = ({
  tag,
  tagTitle,
  onClick,
  onDelete,
  first = false,
  last = false,
  bottomSpacing = false,
  compact = false,
  tagList = false,
  className
}: ITag) => {
  const deleteClick = event => {
    if (!onDelete) return;
    event.preventDefault();
    event.stopPropagation();
    onDelete(event);
  };
  return <IconButton className={cx(chipStyles, bottomSpacing && bottomMarginStyles, tagList && tagListStyles, compact && compactStyles, first && noFirstMarginStyles, last && noLastMarginStyles, !!onDelete && deleteIconColorStyles, className)} onClick={event => onClick(tag, event)} data-testid="Chip__Tag" title={tagTitle ? tagTitle : tag}>
            <span className={tagLabelStyle}>{tag}</span>
            {onDelete && <span className={cx('delete-icon', deleteIconStyles)} onClick={deleteClick}>
                    <Icon path={mdiCloseCircle} size={`1.3rem`} />
                </span>}
        </IconButton>;
};
export default Tag;